export enum EArtistImageType {
    ARTIST_IMAGE = 'artist_image',
    STOCK_IMAGE = 'stock_image',
    LAST_STOCK_IMAGE = 'last_stock_image'
}
